module.exports = __webpack_public_path__ + "img/orange_049.564aaa8d.png";